import { Fragment, useEffect } from "react";
import Header from "./components/home/header";
import Home from "./components/home/home";
import About from "./components/about";
import Resume from "./components/resume";
import Skills from "./components/skills";
import Works from "./components/works";
import AOS from "aos";
import Contacts from "./components/contacts";
import Footer from "./components/footer/footer";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import NotFound from "./components/404/404";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 70,
    });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Fragment>
              <Header />
              <Home />
              <About />
              <Resume />
              <Skills />
              <Works />
              <Contacts />
              <Footer />
            </Fragment>
          }
        />
        <Route
          path="*"
          element={
            <Fragment>
              <Header is404="true" />
              <NotFound />
              <Footer />
            </Fragment>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
